import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import NextLink from 'components/NextLink';
import LookIcon from 'features/rfp/ui/icons/LookIcon';

import { RoutesRFP } from 'config/routes';
import useAnalytics from 'hooks/useAnalytics';

import styles from './styles.styl';

const RFPProfileLink = ({ domain }) => {
  const { elementClick } = useAnalytics();

  return (
    <NextLink
      onClick={() => elementClick('80lv_articles_author_rfp-profile-click')}
      route={RoutesRFP.Profile}
      params={{ domain }}
      targetBlank
    >
      <Button className={styles.RFPProfileLink}>
        <span className={styles.RFPProfileLink__text}>Profile</span>
        <LookIcon fill="#B0B49C" width="20" height="16" className={styles.RFPProfileLink__icon} />
      </Button>
    </NextLink>
  );
};

RFPProfileLink.propTypes = {
  domain: PropTypes.string,
};

export default RFPProfileLink;
